import { render } from "./OnlyLabel.vue?vue&type=template&id=4bf575d0"
import script from "./OnlyLabel.vue?vue&type=script&lang=js"
export * from "./OnlyLabel.vue?vue&type=script&lang=js"
script.render = render

export default script